import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Header from "./components/Header";
import Album from "./components/Album";
import Carousel from "./components/Carousel";
import CustomCard from "./components/CustomCard";
import HomePage from './pages/Home/HomePage';
import MaaltijdenPage from './pages/Maaltijden/MaaltijdenPage';
import PersonaliaPage from './pages/Personalia/PersonaliaPage';
import LoginPage from './pages/Login/LoginPage';
import UploadPage from "./pages/Upload/UploadPage";
import TestPage from "./pages/Test/TestPage";

import { useContext } from 'react';
import AuthContext from './store/auth-context';

import "./App.css";

// An index route cannot have child routes.
function App() {
  const authCtx = useContext(AuthContext);
  //console.log('authCtx', authCtx);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Header />}>
          {authCtx.isLoggedIn && <Route index element={<HomePage />} />}
          {!authCtx.isLoggedIn && <Route index element={<LoginPage />} />}
          <Route path="react/test" element={<TestPage />} />
          <Route path="react/album" element={<Album />} />
          <Route path="react/carousel" element={<Carousel />} />
          <Route path="react/customcard" element={<CustomCard />} />
          <Route path="react/maaltijden" element={<MaaltijdenPage />} />
          <Route path="react/personalia" element={<PersonaliaPage />} />
          <Route path="react/upload" element={<UploadPage />} />
          <Route path="react/login" element={<LoginPage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;